import request from '@/api/request';

const defaultRequest = request();

export function getAccounts (params) {
  return defaultRequest({
    url: '/account',
    method: 'get',
    params
  });
}

export function getAccountById (accountId) {
  return defaultRequest({
    url: '/account/detail',
    method: 'get',
    params: { accountId }
  });
}

export function getDeviceByAccount (params) {
  return defaultRequest({
    url: '/account/device',
    method: 'get',
    params
  });
}

export function getVehicleByAccount (params) {
  return defaultRequest({
    url: '/account/vehicle',
    method: 'get',
    params
  });
}

export function getSimByAccount (params) {
  return defaultRequest({
    url: '/account/sim',
    method: 'get',
    params
  });
}

export function getAccountByParent (params) {
  return defaultRequest({
    url: '/account/getlistbyparent',
    method: 'get',
    params
  });
}

export function getUserByAccount (params) {
  return defaultRequest({
    url: '/account/user',
    method: 'get',
    params
  });
}

export function getDealers () {
  return defaultRequest({
    url: '/account/dealer',
    method: 'get'
  });
}

export function getDealerByAccount (accountId) {
  return defaultRequest({
    url: '/account/getlistdealer',
    method: 'get',
    params: { accountId }
  });
}

export function getDistributors () {
  return defaultRequest({
    url: '/account/getlistdistributor',
    method: 'get'
  });
}

export function checkEmail (email) {
  return defaultRequest({
    url: '/account/checkemail',
    method: 'get',
    params: { email }
  });
}

export function checkPhone (phoneNumber) {
  return defaultRequest({
    url: '/account/checkphone',
    method: 'get',
    params: { phoneNumber }
  });
}

export function createAccount (data) {
  return defaultRequest({
    url: '/account',
    method: 'post',
    data
  });
}

export function importDealer (data) {
  return defaultRequest({
    url: '/account/importdealer',
    method: 'post',
    data
  });
}

export function updateAccountToDealer (data) {
  return defaultRequest({
    url: '/account/updateaccounttodealer',
    method: 'put',
    data
  });
}

export function updateAccountByAdmin (data) {
  return defaultRequest({
    url: '/account/update',
    method: 'put',
    data
  });
}

export function getLog (params) {
  return defaultRequest({
    url: '/account/getlog',
    method: 'get',
    params
  });
}

export function updatemanageduser (data) {
  return defaultRequest({
    url: '/account/updatemanageduser',
    method: 'put',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/account.js